import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

type TTextProps = React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLParagraphElement>,
    HTMLParagraphElement
>;

export const Text = ({ children, className, ...props }: TTextProps) => {
    return (
        <p
            className={twMerge(
                classNames('m-0 font-reg text-primary-10', className)
            )}
            {...props}
        >
            {children}
        </p>
    );
};

export const SuccessText = ({ children, className, ...props }: TTextProps) => {
    return (
        <p
            className={twMerge(
                classNames('m-0 font-med text-success-drk', className)
            )}
            {...props}
        >
            {children}
        </p>
    );
};

export const ErrorText = ({ children, className, ...props }: TTextProps) => {
    return (
        <p
            className={twMerge(
                classNames('m-0 font-med text-error', className)
            )}
            {...props}
        >
            {children}
        </p>
    );
};
